import { css } from "@emotion/css"
import { useContext } from "react"

import Spacer from "@p-ban/common/src/components/layout/Spacer"
import Stack from "@p-ban/common/src/components/layout/Stack"

import type { EstimateErrors } from "../../../../../api/estimate/csComEst.d"
import SPEC_CATEGORIES from "../../../constant/specCategories"
import type { EventHandlers } from "../../../types"
import type EstimateValues from "../../../types/params"
import OneClickEstimateContext from "../../OneClickEstimateContext"
import OneClickFieldContainer from "../../components/1Click/form/OneClickFieldContainer"
import SectionHeading from "../../components/1Click/form/SectionHeading"
import DisabledOverlay from "../../components/1Click/overlay/DisabledOverlay"
import COLOR_CODE from "../../constant/color"
import Z_INDEX from "../../constant/zIndex"
import getSpecCategoryDisplayCondition from "../../service/specCategories/getSpecCategoryDisplayCondition"
import パターン面 from "./01_基本情報/パターン面"
import メタル材質 from "./01_基本情報/メタル材質/メタル材質"
import 外形寸法 from "./01_基本情報/外形寸法/外形寸法"
import 構成層数 from "./01_基本情報/構成層数/構成層数"
import 矩形形状 from "./01_基本情報/矩形形状/矩形形状"
import BGA_CSP from "./02_設計/BGA／CSP/BGA／CSP"
import CAD選択 from "./02_設計/CAD選択"
import シルク追加10個以上 from "./02_設計/シルク追加10個以上（部品番号・ピン番除く）/シルク追加10個以上（部品番号・ピン番除く）"
import ピン数 from "./02_設計/ピン数"
import 回路図の支給形態 from "./02_設計/回路図の支給形態"
import 固有の仕様書_設計指示書 from "./02_設計/固有の仕様書・設計指示書/固有の仕様書・設計指示書"
import 外形が特殊形状_カードエッジコネクタ from "./02_設計/外形が特殊形状・カードエッジコネクタ/外形が特殊形状・カードエッジコネクタ"
import 配線配置ルール from "./02_設計/配置／配線（配線幅・配線長・シールド）ルール/配置／配線（配線幅・配線長・シールド）ルール"
import 高電流_高電圧_多電源 from "./02_設計/高電流（10A以上）高電圧（50V以上）多電源（4種以上）/高電流（10A以上）高電圧（50V以上）多電源（4種以上）"
import 製造枚数 from "./03_製造/製造枚数"
import お客様支給部品 from "./04_実装/お客様支給部品"
import マウントデータの支給 from "./04_実装/マウントデータの支給"
import メタルマスクの製造支給選択 from "./04_実装/メタルマスクの製造・支給選択"
import 半田種類 from "./04_実装/半田種類"
import 実装方法 from "./04_実装/実装方法/実装方法"
import 実装枚数 from "./04_実装/実装枚数/実装枚数"
import 挿入部品 from "./04_実装/挿入部品/挿入部品"
import 無料提供部品 from "./04_実装/無料提供部品"
import 表面実装部品 from "./04_実装/表面実装部品/表面実装部品"
import 部材到着予定日 from "./04_実装/部材到着予定日/部材到着予定日"
import ビルドアップ工法 from "./11_基材/ビルドアップ工法/ビルドアップ工法"
import ベース材厚 from "./11_基材/ベース材厚/ベース材厚"
import ベースコアの厚み from "./11_基材/ベース／コアの厚み/ベース／コアの厚み"
import 材質 from "./11_基材/材質/材質"
import 板厚 from "./11_基材/板厚/板厚"
import 銅箔厚み from "./11_基材/銅箔厚み/銅箔厚み"
import レーザービア径 from "./12_設計基準/レーザービア径／ランド径/レーザービア径／ランド径"
import 最小パターン幅 from "./12_設計基準/最小パターン幅／間隔/最小パターン幅／間隔"
import 最小ビア径 from "./12_設計基準/最小ビア径／ランド径/最小ビア径／ランド径"
import 特性インピーダンスコントロール from "./12_設計基準/特性インピーダンスコントロール/特性インピーダンスコントロール"
import レジスト色 from "./13_レジスト印刷/レジスト色/レジスト色"
import 塗布する面 from "./13_レジスト印刷/塗布する面/塗布する面"
import カバーレイ from "./14_カバーレイ/カバーレイ"
import カバーレイ色 from "./14_カバーレイ/カバーレイ色/カバーレイ色"
import 貼る面 from "./14_カバーレイ/貼る面/貼る面"
import シルク印刷工法 from "./15_シルク印刷/シルク印刷工法/シルク印刷工法"
import シルク印刷色 from "./15_シルク印刷/シルク印刷色/シルク印刷色"
import 印刷する面 from "./15_シルク印刷/印刷する面/印刷する面"
import 端子部のみ電解金めっき from "./16_仕上げ/端子部のみ電解金めっき/端子部のみ電解金めっき"
import 端子部の面取り加工 from "./16_仕上げ/端子部の面取り加工/端子部の面取り加工"
import 表面処理 from "./16_仕上げ/表面処理/表面処理"
import 端子部厚み指定 from "./17_補強板/端子部厚み指定/端子部厚み指定"
import 補強板厚み指定 from "./17_補強板/補強板厚み指定/補強板厚み指定"
import FPC面付けされたデータ from "./18_面付情報/FPC面付けされたデータ/FPC面付けされたデータ"
import Vカット from "./18_面付情報/Vカット/Vカット"
import ジャンプVカット from "./18_面付情報/ジャンプVカット/ジャンプVカット"
import データ面付け編集サービス from "./18_面付情報/データ面付け編集サービス/データ面付け編集サービス"
import ミシン目面付け from "./18_面付情報/ミシン目面付け/ミシン目面付け"
import ルーター切り出し面付け from "./18_面付情報/ルーター切り出し面付け/ルーター切り出し面付け"
import 面付け数 from "./18_面付情報/面付け数/面付け数"
import _03mm未満のパッド from "./19_特殊加工/0.3mm未満のパッド/0.3mm未満のパッド"
import パッドオンビア from "./19_特殊加工/パッド・オン・ビア/パッド・オン・ビア"
import 端面スルーホール from "./19_特殊加工/端面スルーホール/端面スルーホール"
import 長穴 from "./19_特殊加工/長穴/長穴"
import 電磁波シールド from "./19_特殊加工/電磁波シールド/電磁波シールド"
import ULマーク from "./20_規格/ULマーク"
import AOI検査 from "./21_検査/AOI検査（外観光学検査）/AOI検査（外観光学検査）"
import 実装検査成績書 from "./21_検査/実装検査成績書/実装検査成績書"
import 製造検査成績書 from "./21_検査/製造検査成績書/製造検査成績書"
import データ形式 from "./22_データ形式など/データ形式"
import 設計CAD from "./22_データ形式など/設計CAD/設計CAD"
import 製造工場 from "./23_工場指定/製造工場"
import AWデータ支給設計 from "./24_特殊設計仕様/AWデータ支給設計（CAD／LIB必須）/AWデータ支給設計（CAD／LIB必須）"
import DDR_IF_EMC設計 from "./24_特殊設計仕様/DDR I／F・EMC設計（伝送線路シミュレーション等）/DDR I／F・EMC設計（伝送線路シミュレーション等）"
import DXFデータ出力 from "./24_特殊設計仕様/DXFデータ出力/DXFデータ出力"
import リジッドフレキ基板 from "./24_特殊設計仕様/リジッドフレキ基板/リジッドフレキ基板"
import ワイヤーボンディング from "./24_特殊設計仕様/ワイヤーボンディング/ワイヤーボンディング"
import 納期短縮対応 from "./24_特殊設計仕様/納期短縮対応/納期短縮対応"
import 面付け from "./24_特殊設計仕様/面付け/面付け"
import ItemSelect from "./アイテム選択/ItemSelect"
import ServiceSelect from "./サービス選択/ServiceSelect"

type Props = {
  values: EstimateValues
  handlers: EventHandlers
  errors?: EstimateErrors
  isInitialized: boolean
  partsListError?: string
}

const EstimateForm = ({ isInitialized, partsListError, ...props }: Props) => {
  const condition = getSpecCategoryDisplayCondition(props.values)
  const { bomSnapshotId } = useContext(OneClickEstimateContext)

  return (
    <form className={styles.form} noValidate>
      <div className={styles.section}>
        {bomSnapshotId && <DisabledOverlay />}
        <ItemSelect {...props} />
        <ServiceSelect {...props} partsListError={partsListError} />
      </div>
      <section className={styles.section}>
        <SectionHeading className="mb-4">基本情報入力</SectionHeading>
        <Stack direction="column" spacing={20}>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.base} isShow={condition.base}>
            <メタル材質 {...props} />
            <構成層数 {...props} />
            <パターン面 {...props} />
            <外形寸法 {...props} />
            <矩形形状 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.design} isShow={condition.design}>
            <ピン数 {...props} />
            <CAD選択 {...props} />
            <回路図の支給形態 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.designRequest} isShow={condition.designRequest}>
            <配線配置ルール {...props} />
            <固有の仕様書_設計指示書 {...props} />
            <高電流_高電圧_多電源 {...props} />
            <BGA_CSP {...props} />
            <外形が特殊形状_カードエッジコネクタ {...props} />
            <シルク追加10個以上 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.manufacture} isShow={condition.manufacture}>
            <製造枚数 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.mount} isShow={condition.mount}>
            <実装枚数 {...props} />
            <半田種類 {...props} />
            <表面実装部品 {...props} />
            <挿入部品 {...props} />
            <実装方法 {...props} />
            <マウントデータの支給 {...props} />
            <メタルマスクの製造支給選択 {...props} />
            <無料提供部品 {...props} />
            <お客様支給部品 {...props} />
            <部材到着予定日 {...props} />
          </OneClickFieldContainer>
        </Stack>
      </section>
      <Spacer size={20} />
      <section className={styles.section}>
        <SectionHeading sub="（省略可能）" subColor={COLOR_CODE.LIGHT_BLACK} className="mb-4">
          詳細設定入力
        </SectionHeading>
        <Stack direction="column" spacing={20}>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.material} isShow={condition.material}>
            <材質 {...props} />
            <板厚 {...props} />
            <ベース材厚 {...props} />
            <ベースコアの厚み {...props} />
            <銅箔厚み {...props} />
            <ビルドアップ工法 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.designCriteria} isShow={condition.designCriteria}>
            <最小パターン幅 {...props} />
            <最小ビア径 {...props} />
            <レーザービア径 {...props} />
            <特性インピーダンスコントロール {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer
            caption={`${SPEC_CATEGORIES.specialDesignSpec}（個別見積りとなります）`}
            isShow={condition.specialDesignSpec}
          >
            <リジッドフレキ基板 {...props} />
            <ワイヤーボンディング {...props} />
            <AWデータ支給設計 {...props} />
            <DDR_IF_EMC設計 {...props} />
            <納期短縮対応 {...props} />
            <DXFデータ出力 {...props} />
            <面付け {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.resistPrinting} isShow={condition.resistPrinting}>
            <塗布する面 {...props} />
            <レジスト色 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.coverlay} isShow={condition.coverlay}>
            <貼る面 {...props} />
            <カバーレイ {...props} />
            <カバーレイ色 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.silkPrinting} isShow={condition.silkPrinting}>
            <印刷する面 {...props} />
            <シルク印刷色 {...props} />
            <シルク印刷工法 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.finishing} isShow={condition.finishing}>
            <表面処理 {...props} />
            <端子部のみ電解金めっき {...props} />
            <端子部の面取り加工 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.reinforcementPlate} isShow={condition.reinforcementPlate}>
            <端子部厚み指定 {...props} />
            <補強板厚み指定 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.imposition} isShow={condition.imposition}>
            <面付け数 {...props} />
            <FPC面付けされたデータ {...props} />
            <Vカット {...props} />
            <ジャンプVカット {...props} />
            <ルーター切り出し面付け {...props} />
            <ミシン目面付け {...props} />
            <データ面付け編集サービス {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.specialProcessing} isShow={condition.specialProcessing}>
            <端面スルーホール {...props} />
            <長穴 {...props} />
            <パッドオンビア {...props} />
            <_03mm未満のパッド {...props} />
            <電磁波シールド {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.standard} isShow={condition.standard}>
            <ULマーク {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.inspection} isShow={condition.inspection}>
            <AOI検査 {...props} />
            <製造検査成績書 {...props} />
            <実装検査成績書 {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.dataFormat} isShow={condition.dataFormat}>
            <データ形式 {...props} />
            <設計CAD {...props} />
          </OneClickFieldContainer>
          <OneClickFieldContainer caption={SPEC_CATEGORIES.factory} isShow={condition.factory}>
            <製造工場 {...props} />
          </OneClickFieldContainer>
        </Stack>
        {!isInitialized && <div className={styles.disabled} />}
      </section>
    </form>
  )
}

export default EstimateForm

const styles = {
  form: css`
    position: relative;
  `,
  disabled: css`
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${Z_INDEX.NOT_INITIALIZED};
    width: 100%;
    height: 100%;
    background-color: ${COLOR_CODE.WHITE};
    opacity: 0.7;
  `,
  section: css`
    position: relative;
    background-color: ${COLOR_CODE.WHITE};
  `,
}
